import { type SelectionsMachine } from '../../../machine/selection-machine';
import { isSameCell } from '../../../machine/utils/is-same-cell';
import { type ClickTarget } from '../utils/get-click-target';

export interface SelectionModifiers {
  extend?: boolean;
  toggle?: boolean;
}

export function dispatchInitialClick(
  machine: SelectionsMachine,
  target: ClickTarget,
  modifiers: SelectionModifiers = {}
): void {
  const { extend = false, toggle = false } = modifiers;
  const state = machine.getState();

  if (target.type === 'headerCheckbox') {
    //TODO: we'll need to handle deselect on click too.
    machine.dispatch({ type: 'selectAll', source: 'mouse' });
  } else if (target.type === 'cell') {
    if (extend && state.mode === 'cell' && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToCell',
        cell: target.position,
        source: 'mouse',
      });
    } else if (
      state.mode === 'cell' &&
      state.focusedCell &&
      isSameCell(state.focusedCell, target.position)
    ) {
      machine.dispatch({
        type: 'startEditing',
        cell: target.position,
        source: 'mouse',
      });
    } else {
      machine.dispatch({ type: 'selectCell', cell: target.position, source: 'mouse' });
    }
  } else if (target.type === 'row') {
    if (extend && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToRow',
        row: target.row,
        source: 'mouse',
      });
    } else if (target.source === 'row-handle') {
      if (toggle) {
        machine.dispatch({ type: 'toggleRow', row: target.row, source: 'mouse' });
      } else {
        machine.dispatch({
          type: 'selectRows',
          ranges: [
            {
              anchor: {
                row: target.row,
                col: {
                  index: 0,
                },
              },
              lead: {
                row: target.row,
                col: {
                  index: 0,
                },
              },
            },
          ],
          source: 'mouse',
        });
      }
    } else {
      machine.dispatch({ type: 'toggleRow', row: target.row, source: 'mouse' });
    }
  } else if (target.type === 'column') {
    if (extend && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToColumn',
        col: target.col,
        source: 'mouse',
      });
    } else if (toggle) {
      machine.dispatch({ type: 'toggleColumn', col: target.col, source: 'mouse' });
    } else {
      machine.dispatch({
        type: 'selectColumns',
        ranges: [
          {
            anchor: {
              col: target.col,
              row: {
                index: 0,
              },
            },
            lead: {
              col: target.col,
              row: {
                index: 0,
              },
            },
          },
        ],
        source: 'mouse',
      });
    }
  }
}
